import React from "react";
import { AntdSecondaryButton } from "./styles";

export default function SecondaryButton({ ...props }) {
	return <AntdSecondaryButton {...props} />;
}
